import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";

import store from "@/store";

import HeaterRows from "./HeaterRows.vue";
import ToolRows from "./ToolRows.vue";

// General appearance

export default /*#__PURE__*/_defineComponent({
  __name: 'ControlList',
  setup(__props) {

const hasTools = computed(() => store.state.machine.model.tools.some(tool => tool !== null));
const hasBeds = computed(() => store.state.machine.model.heat.bedHeaters.some(bedHeater => (bedHeater >= 0) && (bedHeater < store.state.machine.model.heat.heaters.length) && (store.state.machine.model.heat.heaters[bedHeater] !== null)));
const hasChambers = computed(() => store.state.machine.model.heat.chamberHeaters.some(chamberHeater => (chamberHeater >= 0) && (chamberHeater < store.state.machine.model.heat.heaters.length) && (store.state.machine.model.heat.heaters[chamberHeater] !== null)));

// Bed control
const bedHeaters = computed(() => store.state.machine.model.heat.bedHeaters);
const singleBedControl = computed<boolean>(() => store.state.machine.settings.singleBedControl);

// Chamber control
const chamberHeaters = computed(() => store.state.machine.model.heat.chamberHeaters);

// Heater fault management
const resettingHeaterFault = ref(false), faultyHeaterToReset = ref(-1);
function resetHeaterFault(heater: number) {
    faultyHeaterToReset.value = heater;
    resettingHeaterFault.value = true;
}

return { __sfc: true,hasTools, hasBeds, hasChambers, bedHeaters, singleBedControl, chamberHeaters, resettingHeaterFault, faultyHeaterToReset, resetHeaterFault, HeaterRows, ToolRows }
}

})